import React, {Component} from "react";
import {useState, useEffect} from 'react'
import {Link} from 'react-router-dom';
import useFetch from '../APIs/SpotifyGetRelatedArtists.js';
import UserCard from '../Cards/SpotifyUserCard.js';
import LoadingSkeleton from '../LoadingSkeletons/UserCard03.js';
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";


// import required modules
import { Navigation } from "swiper/modules";
const Followers = (props) => {

    //userId,songId,search_string,genre,sort,page,
    
    const [data, setData] = useState(null);
    const [request, setRequest] = useState(null)
    const {data:FetchedData,isLoading, error} = useFetch(request)

    useEffect(()=>{
        if(FetchedData){
            setData(FetchedData)
        }
    },[FetchedData])


    const send_request =()=>{
        setData(null)
        setRequest({
            "user_id":props.data.id,
            "type":"followers",
            "page":1,
        })
    }



    useEffect(()=>{
        send_request()
    },[])

    return (
    <>
   

    {isLoading &&(
        <>
            <div className="htitle">
                <div className="lft"><p>Related Artists</p></div>
            </div>
            {props.innerWidth<992 &&(
                <div className="vertical-container">
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                </div>
            )}
            {props.innerWidth>992 &&(
                <Swiper
                    navigation={true}
                    modules={[Navigation]}
                    breakpoints={{
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        992: {
                            slidesPerView: 5,
                            spaceBetween: 20,
                        },
                        
                        1600: {
                            slidesPerView: 7,
                            spaceBetween: 30,
                        },
                    }}
                    className="mySwiper"
                >
                     <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                     <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                     <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                     <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                     <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                    
                </Swiper>           
            )}
        </>
    )}
     {(data && data.artists.length>0) &&(
        <>
            <div className="htitle">
                <div className="lft"><p>Related Artists</p></div>
                {data.artists.length > 10 &&(
                 <div className="rgt"><p><Link to={'/spotify/profile/followers/'+props.user_id}>See more</Link></p></div>   
                )}
            </div>
            {props.innerWidth<992 &&(
                <div className="vertical-container">
                    {data.artists.slice(0,10).map((user,index)=>{
                            return <UserCard key={index} data = {user} />
                        }
                    )}
                </div>
            )}
            {props.innerWidth>992 &&(
                <Swiper
                    navigation={true}
                    modules={[Navigation]}
                    breakpoints={{
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        992: {
                            slidesPerView: 5,
                            spaceBetween: 20,
                        },
                        
                        1600: {
                            slidesPerView: 7,
                            spaceBetween: 30,
                        },
                    }}
                    className="mySwiper"
                >
                    {data.artists.map((user,index)=>{
                            return <SwiperSlide key={index}><UserCard  data = {user} /></SwiperSlide>
                        }
                    )}
                    
                </Swiper>           
            )}
        </>
    )}
    </>  
    )
}

export default Followers
